import { useState } from 'react';
import { Box, Table, Title } from '@nimbus-ds/components';
import { PaginationStratus } from 'commons/components';
import {
  useGetPartnerAdminAccessQuery,
  useGetRolesQuery,
} from 'domains/Configurations/Users/usersApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import {
  PartnersListDesktopHeader,
  PartnersListDesktopRow,
  PartnersListDesktopSkeleton,
} from './components';
import { usePartnersListDesktop } from '../../hooks';
import UnlinkPartnerModal from '../UnlinkPartnerModal';

function PartnersListDesktop() {
  const {
    data: partners,
    isLoading: isPartnersLoading,
    changePage,
  } = usePartnersListDesktop();
  const t = useTranslationConfigurations('partnersListComponent');
  const { data: storeRoles, isLoading: isRolesLoading } = useGetRolesQuery();
  const { data: partnerAdminAccess } = useGetPartnerAdminAccessQuery();
  const [selectedPartnerToUnlink, setSelectedPartnerToUnlink] = useState<{
    partnerId: number;
    permissionId: number;
    partnerName: string;
    partnerEmail: string;
    isModalOpen: boolean;
  } | null>(null);

  const showSkeleton = isPartnersLoading ?? isRolesLoading;
  const allRoles = { ...storeRoles?.roles, ...storeRoles?.appRoles };

  if (showSkeleton) return <PartnersListDesktopSkeleton />;

  if (!partners || partners?.results?.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Title as="h4">{t('title')}</Title>
      <Table>
        <PartnersListDesktopHeader
          hasPartnerAdminAccess={
            partnerAdminAccess && partnerAdminAccess?.count > 0
          }
        />
        <Table.Body>
          {partners?.results?.map?.((partner, index) => (
            <PartnersListDesktopRow
              key={`partners-list-item-desktop-${partner.partnerId}-${index}`}
              partner={partner}
              storeRoles={allRoles}
              hasPartnerAdminAccess={
                partnerAdminAccess && partnerAdminAccess?.count > 0
              }
              onUnlinkPartner={(unlinkPartner) =>
                setSelectedPartnerToUnlink({
                  partnerId: unlinkPartner.partnerId,
                  permissionId: unlinkPartner.id,
                  partnerName: unlinkPartner.partnerName,
                  partnerEmail: unlinkPartner.partnerEmail,
                  isModalOpen: true,
                })
              }
            />
          ))}
        </Table.Body>
      </Table>
      <PaginationStratus
        currentPage={partners?.pagination?.currentPage}
        totalItems={partners?.pagination?.totalResults}
        itemName={t('partners')}
        page={partners?.pagination?.currentPage}
        perPage={partners?.pagination?.perPage}
        onPageSelect={changePage}
      />
      <UnlinkPartnerModal
        isOpen={selectedPartnerToUnlink?.isModalOpen ?? false}
        onClose={() =>
          setSelectedPartnerToUnlink({
            partnerId: 0,
            permissionId: 0,
            partnerName: '',
            partnerEmail: '',
            isModalOpen: false,
          })
        }
        partnerName={selectedPartnerToUnlink?.partnerName || ''}
        partnerEmail={selectedPartnerToUnlink?.partnerEmail || ''}
        partnerId={selectedPartnerToUnlink?.partnerId ?? 0}
        permissionId={selectedPartnerToUnlink?.permissionId ?? 0}
      />
    </Box>
  );
}

export default PartnersListDesktop;
